export default {
    UNKNOW_ERROR_FETCHING_PROFILE: 'unknownErrorGettingAccountProfile',
};



// WEBPACK FOOTER //
// ./src/services/ProfileService/ProfileServiceConstant.js